import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models';

import { UitkCheckbox } from 'uitk-react-checkbox';

import { FormFieldBinding } from 'components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

interface PartialStayCheckboxProps extends LocalizedComponentProps, SearchFormFieldProps {
  model: SearchCriteriaModel;
}

@withLocalization
@FormFieldBinding
export class PartialStayCheckbox extends React.Component<PartialStayCheckboxProps> {
  private readonly name: string;
  private readonly label: string;

  constructor(props: PartialStayCheckboxProps) {
    super(props);

    this.name = props.modelKey;
    this.label = props.l10n.formatText('multiItem.searchWizard.partialStay.text');

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event) {
    const { updateModel } = this.props;

    if (typeof updateModel === 'function') {
      const { checked } = event.target;

      updateModel({
        target: {
          name: 'partialStay',
          value: String(checked),
          track: true,
        },
      });
    }
  }

  public render() {
    return (
      <div className="uitk-cell s-cell-1-1 m-cell-2-2 l-cell-3-3 xl-cell-3-3">
        <UitkCheckbox
          id={this.name}
          name={this.name}
          value={String(this.props.model.isPartialStay)}
          checked={this.props.model.isPartialStay}
          onChange={this.handleChange}
        >
          {this.label}
        </UitkCheckbox>
      </div>
    );
  }
}
